"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var STATE;
(function (STATE) {
    STATE[STATE["NONE"] = 0] = "NONE";
    STATE[STATE["INACTIVE"] = 1] = "INACTIVE";
    STATE[STATE["READY"] = 2] = "READY";
    STATE[STATE["SENDING"] = 3] = "SENDING";
    STATE[STATE["DEAD"] = 4] = "DEAD";
})(STATE || (STATE = {}));
var KafkaSender = /** @class */ (function () {
    function KafkaSender(config, client, apiUrl, logger) {
        var _a;
        this.state = STATE.NONE;
        this.locked = true;
        this.eventBuffer = [];
        this.retryCount = 0;
        this.config = config;
        this.client = client;
        this.logger = logger;
        this.apiUrl = apiUrl;
        this.stateMap = (_a = {},
            _a[STATE.INACTIVE] = this.enterInactive.bind(this),
            _a[STATE.READY] = this.enterReady.bind(this),
            _a[STATE.SENDING] = this.enterSending.bind(this),
            _a[STATE.NONE] = this.enterNone.bind(this),
            _a[STATE.DEAD] = this.enterDead.bind(this),
            _a);
        this.init();
    }
    KafkaSender.prototype.init = function () {
        var _this = this;
        this.client.get(this.apiUrl)
            .then(function (response) {
            _this.config.endpoint = response.data.kafka_proxy;
            _this.setLocked(false);
            _this.setState(STATE.READY);
        })
            .catch(function (e) { return _this.logger.error(e); });
    };
    KafkaSender.prototype.send = function (event) {
        if (this.state === STATE.DEAD || this.eventBuffer.length > this.config.bufferSize) {
            return; // skip and ignore events when the buffer is full
        }
        this.eventBuffer.push(event);
        if (this.state === STATE.READY && !this.locked) {
            this.setState(STATE.SENDING);
        }
    };
    /**
     * Feed event bundles to analytics service until empty.
     * Assume ready state when event buffer empties.
     */
    KafkaSender.prototype.drainEvents = function () {
        var _this = this;
        if (this.eventBuffer.length === 0) {
            this.logger.info('KafkaSender:drainEvents - DONE');
            this.setState(STATE.READY);
            return;
        }
        // Randomize timings to avoid congestion.
        var jitterSpread = Math.random() * this.config.bundleSendTimeout
            - (this.config.bundleSendTimeout / 2);
        var events = this.eventBuffer.splice(0, this.config.bundleSize);
        this.sendEventBundle(events)
            .catch(function (e) {
            var _a;
            (_a = _this.eventBuffer).push.apply(_a, events); // Attach unsent events to the buffer's end
            _this.retryCount++;
            _this.logger.warn('KafkaSender: bundle send failed', e);
            return true;
        })
            .then(function (isRecovering) {
            if (isRecovering === true && _this.retryCount > _this.config.retries) {
                _this.setState(STATE.DEAD);
                return;
            }
            _this.retryCount = 0; // reset retries after successful request
            setTimeout(function () { return _this.drainEvents(); }, _this.config.bundleSendTimeout + jitterSpread);
        });
    };
    KafkaSender.prototype.sendEventBundle = function (events) {
        if (!this.config.endpoint) {
            throw new Error('bundle send while uninitialized');
        }
        return this.client.post(this.config.endpoint, events);
    };
    /**
     * Assume inactive state. Inactive means we don't send anything.
     */
    KafkaSender.prototype.enterInactive = function () {
        return Promise.resolve(true);
    };
    /**
     * Assume ready state. Will send events as they come.
     */
    KafkaSender.prototype.enterReady = function () {
        return Promise.resolve(true);
    };
    /**
     * Lasciate ogni speranza, voi ch'entrate
     */
    KafkaSender.prototype.enterDead = function () {
        return Promise.resolve(true);
    };
    /**
     * Wait a bit to get more events and start feeding event buffer to analytics service.
     */
    KafkaSender.prototype.enterSending = function () {
        var _this = this;
        return new Promise(function (resolve) {
            setTimeout(function () {
                _this.drainEvents();
                resolve(true);
            });
        });
    };
    /**
     * Required to fully cover possible states
     */
    KafkaSender.prototype.enterNone = function () {
        return Promise.resolve(true);
    };
    /**
     * “Any sufficiently complicated model class contains an ad-hoc,
     * bug-ridden, slow implementation of half of a state machine.”
     */
    KafkaSender.prototype.setState = function (state) {
        var _this = this;
        if (state === this.state) {
            return;
        }
        if (this.locked) {
            return;
        }
        this.setLocked(true);
        this.stateMap[state]().then(function () {
            _this.state = state;
            _this.setLocked(false);
            _this.logger.info('KafkaSender:setState', state, STATE[state]);
        });
    };
    /**
     * Lock means model can't switch state
     */
    KafkaSender.prototype.setLocked = function (locked) {
        this.locked = locked;
    };
    return KafkaSender;
}());
exports.default = KafkaSender;
